import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesReportes() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: null, items: [
      { label: "Ventas", icon: "fas fa-chart-line", color: "#2563eb", href: "/ReporteVentas", desc: "Tendencia, vinos, clientes y perfil kosher", enabled: !!user.menu_reportes },
      { label: "Rentabilidad", icon: "fas fa-percentage", color: "#0d9488", href: "/ReporteRentabilidad", desc: "Utilidad y margen por vino, region y cliente", enabled: !!user.menu_reportes },
      { label: "Utilidades", icon: "fas fa-search-dollar", color: "#10b981", href: "/ReporteUtilidades", desc: "Detalle por venta y por vino con filtros", enabled: !!user.menu_reportes },
      { label: "Inventario", icon: "fas fa-warehouse", color: "#d97706", href: "/ReporteInventario", desc: "Valor, añadas, rotacion y alertas", enabled: !!user.menu_reportes },
      { label: "Compras", icon: "fas fa-file-signature", color: "#7c3aed", href: "/ReporteCompras", desc: "Recepciones, proveedores y atrasos", enabled: !!user.menu_reportes },
      { label: "Cobranza y pagos", icon: "fas fa-coins", color: "#db2777", href: "/ReporteCartera", desc: "Antiguedad de saldos y flujo", enabled: !!user.menu_reportes },
      { label: "IEPS e IVA", icon: "fas fa-landmark", color: "#64748b", href: "/ReporteImpuestos", desc: "Impuestos trasladados por mes y tasa", enabled: !!user.menu_reportes },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Reportes"
      descripcion="Como va el negocio de vinos"
      icono="fas fa-chart-bar"
      color="#2563eb"
      secciones={SECCIONES}
    />
  );
}

export default BotonesReportes;
